export default "__VITE_ASSET__FjSAQRy8__"